import { Chip, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ActiveFilter } from "./mda-types";

interface MdaActiveFiltersProps {
  filters: ActiveFilter[];
  onRemove: (key: string) => void;
}

const MdaActiveFilters = ({ filters, onRemove }: MdaActiveFiltersProps) => (
  <Stack
    direction="row"
    alignItems="center"
    flexWrap="wrap"
    gap={1}
    sx={{ px: { xs: 2, sm: 2.5 }, py: 1.5 }}
  >
    <Typography
      variant="caption"
      sx={{ color: "#24344d", fontWeight: 700, mr: 1 }}
    >
      Active filters:
    </Typography>
    {filters.length === 0 ? (
      <Typography variant="caption" sx={{ color: "#8290a4" }}>
        None
      </Typography>
    ) : (
      filters.map((filter) => (
        <Chip
          key={filter.key}
          label={filter.label}
          size="small"
          onDelete={() => onRemove(filter.key)}
          deleteIcon={<CloseIcon />}
          sx={{
            border: "1px solid #d9e1ed",
            backgroundColor: "#fff",
            color: "#53637a",
            "& .MuiChip-deleteIcon": {
              color: "#8190a5",
              fontSize: 16,
            },
          }}
        />
      ))
    )}
  </Stack>
);

export default MdaActiveFilters;
